exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "*[data-v-cdf31a0a]{margin:0;padding:0}#app[data-v-cdf31a0a]{position:relative;display:flex;width:100%;height:100vh;flex-direction:column}#app .navigation[data-v-cdf31a0a]{height:50px}#app .app-body[data-v-cdf31a0a]{flex:1;background-color:#f2f2f2}#app .loading[data-v-cdf31a0a]{position:fixed;top:0;left:0;background-color:rgba(0,0,0,.75)}.loading .loading-text[data-v-cdf31a0a]{position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);font-size:2.5rem;color:hsla(0,0%,100%,.5)}", ""]);

// exports
